
import { RevInputSelect } from '@ds/components/InputSelect'
import { RevPopover } from '@ds/components/Popover'
import { RevRadio } from '@ds/components/Radio'
import { RevTooltip } from '@ds/components/Tooltip'
import isEmpty from 'lodash/isEmpty'

import { tw } from '@core/tailwind'

const INPUT_TYPES = {
  SELECT: 'select',
  RADIO: 'radio_line',
}

export default {
  components: {
    RevRadio,
    RevInputSelect,
    RevPopover,
    RevTooltip,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    helpTitle: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    scroll: {
      type: Boolean,
      default: true,
    },
    last: {
      type: Boolean,
      default: false,
    },
    isAnswered: {
      type: Boolean,
      default: false,
    },
    appearance: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary'].includes(value),
    },
    scrollEffect: {
      type: String,
      default: 'start',
      validator: (value) => ['start', 'end'].includes(value),
    },
  },
  data() {
    return {
      selectValue: '',
      radioValue: null,
    }
  },
  computed: {
    INPUT_TYPES: () => INPUT_TYPES,
    isScrollEndSpacing() {
      return this.scrollEffect === 'end' && !this.isAnswered
    },
    hasHelpText() {
      return !isEmpty(this.helpText)
    },
    radioWrapperClasses() {
      return this.options.length > 2 ? tw`flex-col` : ''
    },
    radioClasses() {
      return this.options.length > 2 ? tw`my-1` : ''
    },
    popoverModifiers() {
      return [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top'],
          },
        },
      ]
    },
  },
  methods: {
    afterEnter(el) {
      if (this.scroll && el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: this.scrollEffect,
          inline: 'nearest',
        })
      }
    },
    completed(value) {
      this.$emit('completed', value)
    },
  },
}
